import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import OpalGrid from '../../../../organisms/DenaliAnalysis/tables/operational'

function BatchTasksTable ({ tasks, total, loading, filter, pageState, sortState, onPageChange, onSortChange }) {
  const columns = useMemo(() => {
    const cols = [
      { accessorKey: 'batchTaskId', header: 'Task ID', size: 80 },
      {
        id: 'clientId',
        header: 'Client ID',
        accessorFn: (row) => row.taskData?.clientId ?? '-',
        size: 100
      },
      {
        id: 'taskStatus',
        header: 'Status',
        accessorFn: (row) => row.isComplete ? 'completed' : row.isError ? 'errored' : 'pending',
        cell: ({ getValue }) => {
          const val = getValue()
          if (val === 'completed') return <span style={{ color: 'var(--color-success-500)', fontWeight: 600 }}>Completed</span>
          if (val === 'errored') return <span style={{ color: 'var(--color-danger-500)', fontWeight: 600 }}>Error</span>
          return <span style={{ color: 'var(--color-neutral-400)' }}>Pending</span>
        },
        size: 100
      }
    ]

    if (filter === 'completed' || filter === 'all') {
      cols.push({
        id: 'statusReportId',
        header: 'Report ID',
        accessorFn: (row) => row.resultData?.statusReportId ?? '-',
        enableSorting: false,
        size: 100
      })
    }

    if (filter === 'errored' || filter === 'all') {
      cols.push({
        id: 'errorCode',
        header: 'Error Code',
        accessorFn: (row) => row.errorData?.errorCode ?? '',
        cell: ({ getValue }) => {
          const code = getValue()
          if (!code) return null
          return <span className='px-1 radius-sm font-size-xs font-bold' style={{ backgroundColor: 'var(--color-danger-050)', color: 'var(--color-danger-500)', fontFamily: 'monospace' }}>{code}</span>
        },
        enableSorting: false,
        size: 160
      })
      cols.push({
        id: 'errorMessage',
        header: 'Message',
        accessorFn: (row) => row.errorData?.message ?? '',
        cell: ({ getValue }) => (
          <div style={{ maxWidth: '250px', fontSize: '0.8rem', color: 'var(--color-neutral-500)' }}>
            {getValue()}
          </div>
        ),
        enableSorting: false,
        size: 250
      })
    }

    return cols
  }, [filter])

  return (
    <div>
      <OpalGrid
        data={tasks}
        rowCount={total}
        columns={columns}
        isFetching={loading}
        pageState={pageState}
        sortState={sortState}
        onPageChange={onPageChange}
        onSortChange={onSortChange}
      />
    </div>
  )
}

BatchTasksTable.propTypes = {
  tasks: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  filter: PropTypes.string,
  pageState: PropTypes.object.isRequired,
  sortState: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired
}

export default BatchTasksTable
